<script setup>
const goBack = () => {
  window.history.back();
};
</script>

<template>
  <div class="back-arrow" @click="goBack">
    <img src="/images/arrow.svg" alt="Back arrow" class="arrow-icon" />
    <span>Zpět</span>
  </div>
</template>

<style scoped>
.back-arrow {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.3s ease;
  margin-bottom: 4rem;
  span {
    text-transform: uppercase;
    font-weight: 900;
    font-size: 20px;
  }
}

.arrow-icon {
  width: 0.75rem;
  transform: rotate(180deg); /* Rotating the arrow */
  margin-right: 1rem; /* Add some space between the arrow and text */
}
</style>
